<template>
  <div :data-field-group-name="data.tag">
    <div class="form-group" v-show="this.data.visibility !== 'hidden'">
      <label v-show="this.showLabel"> {{label}} </label>
	  <label :for="'file'+data.field_id" class="upload-trigger form-control">
		<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
			<path d="M12.3077 13.5385C12.3077 13.3718 12.2468 13.2276 12.125 13.1058C12.0032 12.984 11.859 12.9231 11.6923 12.9231C11.5256 12.9231 11.3814 12.984 11.2596 13.1058C11.1378 13.2276 11.0769 13.3718 11.0769 13.5385C11.0769 13.7051 11.1378 13.8494 11.2596 13.9712C11.3814 14.0929 11.5256 14.1538 11.6923 14.1538C11.859 14.1538 12.0032 14.0929 12.125 13.9712C12.2468 13.8494 12.3077 13.7051 12.3077 13.5385ZM14.7692 13.5385C14.7692 13.3718 14.7083 13.2276 14.5865 13.1058C14.4647 12.984 14.3205 12.9231 14.1538 12.9231C13.9872 12.9231 13.8429 12.984 13.7212 13.1058C13.5994 13.2276 13.5385 13.3718 13.5385 13.5385C13.5385 13.7051 13.5994 13.8494 13.7212 13.9712C13.8429 14.0929 13.9872 14.1538 14.1538 14.1538C14.3205 14.1538 14.4647 14.0929 14.5865 13.9712C14.7083 13.8494 14.7692 13.7051 14.7692 13.5385ZM16 11.3846V14.4615C16 14.7179 15.9103 14.9359 15.7308 15.1154C15.5513 15.2949 15.3333 15.3846 15.0769 15.3846H0.923077C0.666667 15.3846 0.448718 15.2949 0.269231 15.1154C0.0897436 14.9359 0 14.7179 0 14.4615V11.3846C0 11.1282 0.0897436 10.9103 0.269231 10.7308C0.448718 10.5513 0.666667 10.4615 0.923077 10.4615H5.02885C5.16346 10.8205 5.38942 11.1154 5.70673 11.3462C6.02404 11.5769 6.37821 11.6923 6.76923 11.6923H9.23077C9.6218 11.6923 9.97596 11.5769 10.2933 11.3462C10.6106 11.1154 10.8365 10.8205 10.9712 10.4615H15.0769C15.3333 10.4615 15.5513 10.5513 15.7308 10.7308C15.9103 10.9103 16 11.1282 16 11.3846ZM12.875 5.15385C12.766 5.41026 12.5769 5.53846 12.3077 5.53846H9.84615V9.84615C9.84615 10.0128 9.78526 10.1571 9.66346 10.2788C9.54167 10.4006 9.39744 10.4615 9.23077 10.4615H6.76923C6.60256 10.4615 6.45833 10.4006 6.33654 10.2788C6.21474 10.1571 6.15385 10.0128 6.15385 9.84615V5.53846H3.69231C3.42308 5.53846 3.23397 5.41026 3.125 5.15385C3.01603 4.90385 3.0609 4.68269 3.25962 4.49038L7.56731 0.182692C7.68269 0.0608974 7.82692 0 8 0C8.17308 0 8.31731 0.0608974 8.43269 0.182692L12.7404 4.49038C12.9391 4.68269 12.984 4.90385 12.875 5.15385Z" fill="#4D6C8E"/>
		</svg>
	  </label>
      <input type="file" :id="'file'+data.field_id" :accept="data.accept" :multiple="data.multiple == 'yes'" :name="data.tag" style="display: none;"/>
      <small class="form-text text-muted"  style="width: 100%" v-show="data.help_text != ''">{{data.help_text}}</small>
    </div>
  </div>
</template>

<script>
	export default {
		name: 'FileMailingBoss',
		props: ['label', 'selected', 'data', 'showPlaceholder', 'showLabel'],
		data() {
			return {}
		},
		computed: {
			placeholder() {
				return this.showPlaceholder ? this.label : ''
			},
			required() {
				return this.data.required === 'yes';
			}
		}
	}
</script>
<style lang="css">
label.upload-trigger {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/editor/apps/Forms/Fields/FileField.vue